import ResultsModalBody from './ResultsModalBody';

export default ResultsModalBody;
